<template>
  <!-- Работа мастеров: период по order.archived_at -->
  <div :class="workPanelClass">
<!--    <Panel :header="$t('technicianWorkLabel') + (periodLabel ? ' (' + periodLabel + ')' : '')">-->
    <Panel>
      <template #header>
        <div class="statistics-panel-header">
          <b>{{ $t('technicianWorkLabel') }}</b>
          <span v-if="periodLabel" class="p-text-secondary statistics-panel-date">
            {{ periodLabel }}
          </span>
        </div>
      </template>
      <template v-if="workStatistics.length">
        <div class="datatable-wrapper">
          <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
            <thead class="p-datatable-thead">
            <tr class="table-opened-info__header-row">
              <th>{{ $t('technicianLabel') }}</th>
              <th>{{ $t('technicianServiceTimeLabel') }}</th>
              <th>{{ $t('technicianActiveOrdersTimeLabel') }}</th>
            </tr>
            </thead>

            <tbody class="p-datatable-tbody">
            <tr v-for="statistics in workStatistics"
                :key="statistics.is_unassigned ? 'unassigned' : statistics.user_id">
              <td>
                <span v-if="statistics.is_unassigned">
                  {{ $t('unassignedTechnicianLabel') }}
                </span>
                <span v-else>
                  {{ statistics.name }}
                </span>
              </td>

              <td>
                <span v-if="hasTime(statistics.service_time)">
                  {{ formatHoursAndMinutes(statistics.service_time) }}
                </span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="hasTime(statistics.active_service_time)">
                  {{ formatHoursAndMinutes(statistics.active_service_time) }}
                </span>
                <i v-else class="ti-minus"/>
              </td>
            </tr>

            <tr class="table-opened-info__row--total">
              <td class="no-bottom-border">
                {{ $t('Total') }}
              </td>

              <td class="no-bottom-border">
                {{ formatHoursAndMinutes(computedTotalServiceTime) }}
              </td>

              <td class="no-bottom-border">
                <span v-if="hasTime(computedTotalActiveServiceTime)">
                  {{ formatHoursAndMinutes(computedTotalActiveServiceTime) }}
                </span>
                <i v-else class="ti-minus"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>

      <div
          v-else
          style="text-align: center; padding: 20px;">
        {{ $t('No data available') }}
      </div>
    </Panel>
  </div>

  <div v-if="showFinancialData" :class="paymentsPanelClass">
<!--    <Panel v-if="showFinancialData"-->
<!--           :header="$t('technicianEarnings') + (periodLabel ? ' (' + periodLabel + ')' : '')">-->
    <Panel>
      <template #header>
        <div class="statistics-panel-header">
          <b>{{ $t('technicianEarnings') }}</b>
          <span v-if="periodLabel" class="p-text-secondary statistics-panel-date">
            {{ periodLabel }}
          </span>
        </div>
      </template>
      <template v-if="paymentStatistics.length">
        <div class="datatable-wrapper">
          <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
            <thead class="p-datatable-thead">
            <tr class="table-opened-info__header-row">
              <th>{{ $t('technicianLabel') }}</th>

              <th>
                {{ $t('technicianPaymentTimeLabel') }}
              </th>

              <th>
                {{ $t('Earnings') }}
              </th>

              <th>
                {{ $t('averageHourlyEarningsLabel') }} /
                {{ $t('h') }}
              </th>
            </tr>
            </thead>

            <tbody class="p-datatable-tbody">
            <tr
                v-for="statistics in paymentStatistics"
                :key="statistics.user_id">

              <td>
                {{ statistics.name }}
              </td>

              <td>
                  <span v-if="hasTime(statistics.payment_time)">
                    {{ formatHoursAndMinutes(statistics.payment_time) }}
                  </span>

                <i v-else class="ti-minus"/>
              </td>

              <td>
                  <span v-if="hasAmount(statistics.sum)">
                    {{ formatCurrency(statistics.sum) }}
                  </span>

                <i v-else class="ti-minus"/>
              </td>

              <td>
                  <span v-if="hasAmount(hourlyEarnings(statistics))">
                    {{ formatCurrency(hourlyEarnings(statistics)) }}
                  </span>

                <i v-else class="ti-minus"/>
              </td>
            </tr>

            <tr class="table-opened-info__row--total">
              <td class="no-bottom-border">
                {{ $t('Total') }}
              </td>

              <td class="no-bottom-border">
                  <span v-if="hasTime(computedTotalPaymentTime)">
                    {{ formatHoursAndMinutes(computedTotalPaymentTime) }}
                  </span>

                <i v-else class="ti-minus"/>
              </td>

              <td class="no-bottom-border">
                {{ formatCurrency(computedPaymentsSum) }}
              </td>

              <td class="no-bottom-border">
                  <span v-if="hasAmount(computedAverageHourlyEarnings)">
                    {{ formatCurrency(computedAverageHourlyEarnings) }}
                  </span>

                <i v-else class="ti-minus"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>

      <div
          v-else
          style="text-align: center; padding: 20px;">
        {{ $t('No data available') }}
      </div>
    </Panel>
  </div>
</template>

<script>
import formatMixins from '@/mixins/formatMixins'

export default {
  name: 'MastersProductionPanel',

  mixins: [
    formatMixins
  ],

  props: {
    periodLabel: { type: String, default: '' },
    mastersProduction: {
      type: Array,
      default: () => []
    },

    showFinancialData: {
      type: Boolean,
      default: true
    },

    workPanelClass: {
      type: [String, Array, Object],
      default: 'p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3'
    },

    paymentsPanelClass: {
      type: [String, Array, Object],
      default: 'p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3'
    },
  },

  computed: {
    /*
     * Не показываем в таблице работы сотрудников,
     * у которых есть только начисления за выбранный период.
     */
    workStatistics() {
      return (this.mastersProduction || []).filter(item => {
        return (
            item.is_unassigned ||
            this.hasTime(item.service_time) ||
            this.hasTime(item.active_service_time)
        )
      })
    },

    /*
     * Не показываем в таблице начислений сотрудников,
     * у которых в выбранном периоде была только работа.
     */
    paymentStatistics() {
      return (this.mastersProduction || []).filter(item => {
        return (
            this.hasTime(item.payment_time) ||
            this.hasAmount(item.sum)
        )
      })
    },

    computedTotalServiceTime() {
      return this.workStatistics.reduce(
          (total, item) => {
            return total + Number(item.service_time || 0)
          },
          0
      )
    },

    computedTotalActiveServiceTime() {
      return this.workStatistics.reduce(
          (total, item) => {
            return total + Number(item.active_service_time || 0)
          },
          0
      )
    },

    computedTotalPaymentTime() {
      return this.paymentStatistics.reduce(
          (total, item) => {
            return total + Number(item.payment_time || 0)
          },
          0
      )
    },

    computedPaymentsSum() {
      return this.paymentStatistics.reduce(
          (total, item) => {
            return total + Number(item.sum || 0)
          },
          0
      )
    },

    computedAverageHourlyEarnings() {
      if (!this.computedTotalPaymentTime) {
        return 0
      }

      return (
          this.computedPaymentsSum /
          this.computedTotalPaymentTime
      )
    }
  },

  methods: {
    hasTime(value) {
      const time = Number(value)

      return Number.isFinite(time) && time > 0
    },

    hasAmount(value) {
      const amount = Number(value)

      return Number.isFinite(amount) && amount !== 0
    },

    hourlyEarnings(item) {
      const paymentTime = Number(item?.payment_time || 0)
      const sum = Number(item?.sum || 0)

      if (!paymentTime) {
        return 0
      }

      return sum / paymentTime
    }
  }
}
</script>